import Heading from 'components/Luxkit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LineDollarSignAltIcon from 'components/Luxkit/Icons/line/LineDollarSignAltIcon'
import LineClockDollarIcon from 'components/Luxkit/Icons/line/LineClockDollarIcon'
import LineStarIcon from 'components/Luxkit/Icons/line/LineStarIcon'
import LineCommentsAltIcon from 'components/Luxkit/Icons/line/LineCommentsAltIcon'
import LineBedQueenIcon from 'components/Luxkit/Icons/line/LineBedQueenIcon'

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
  margin: ${rem(40)} 0;
`

const TourUSPSection = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(5, 260px);
  grid-auto-columns: 100%;
  gap: ${rem(24)};
  align-items: start;
  height: fit-content;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  ${mediaQueryUp.sm} {
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
  }
`

function TourUSPContainer() {
  return (
    <Root>
      <Heading variant="heading2">Why you should <i>book</i> with us</Heading>
      <TourUSPSection>
        <VerticalSpacer gap={8}>
          <LineStarIcon />
          <BodyText variant="medium" weight="bold">Exclusive tours, curated by experts</BodyText>
          <BodyText variant="medium">
            Uncover unique adventures with tours exclusively handcrafted by our seasoned experts.
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={8}>
          <LineDollarSignAltIcon />
          <BodyText variant="medium" weight="bold">Great value small-group tours</BodyText>
          <BodyText variant="medium">
            Discover intimate and immersive itineraries with our exceptional value small-group tours.
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={8}>
          <LineClockDollarIcon />
          <BodyText variant="medium" weight="bold">7-day cooling off period</BodyText>
          <BodyText variant="medium">
            Enjoy peace of mind with our 7-day 'no questions asked' cooling off period.
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={8}>
          <LineBedQueenIcon />
          <BodyText variant="medium" weight="bold">Handpicked accommodation and VIP experiences</BodyText>
          <BodyText variant="medium">
            Luxury Escapes branded tours are curated by our team of experts and include all the extras you love.
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={8}>
          <LineCommentsAltIcon />
          <BodyText variant="medium" weight="bold">24/7 dedicated tours concierge</BodyText>
          <BodyText variant="medium">
            Our dedicated tours concierge is available online or on the phone anytime, whenever you need us.
          </BodyText>
        </VerticalSpacer>
      </TourUSPSection>
    </Root>
  )
}

export default TourUSPContainer
